import * as React from 'react';
import styled from 'styled-components';
import { lighten, darken } from 'polished';

import { colors } from '../styles/variables';

interface IButtonProps {
  children: any;
  href: string;
  onClick?: Function;
  isLoading?: boolean;
  primary?: boolean;
  className?: string;
  snowItemButton?: boolean;
}

const ButtonView = styled.a<{ primary?: boolean, onClick: any }>`
  color: ${props => props.primary ? colors.white : colors.red};
  background-color: ${props => props.primary ? colors.red : colors.white};
  border: 1px solid ${colors.red};
  padding: 0.5rem 1rem;
  border-radius: 4px;
  text-decoration: none;
  min-width: 100px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
  &:hover {
    color: ${props => props.primary ? colors.white : colors.red};
    background-color: ${props => props.primary ? darken(0.05, colors.red) : lighten(0.35, colors.red)};
    text-decoration: none;
  }
`

const Button: React.FC<IButtonProps> = ({ children, href, onClick, isLoading, primary, className, snowItemButton }) => {
  if (snowItemButton) {
    return (
      <a href={href} onClick={onClick as any} data-turbolinks="false" className={`w-100 btn btn-primary rounded-pill ${className ? className : ''}`}>
        {isLoading ? <i className="fas fa-spinner fa-spin" /> : children}
      </a>
    )
  } else {
    return (
      <ButtonView href={href} onClick={onClick} primary={primary} data-turbolinks="false" className={className ? className : ''}>
        {isLoading ? <i className="fas fa-spinner fa-spin" /> : children}
      </ButtonView>
    )
  }
}

export default Button;
